import { getValue } from '../../utils/TimeSpanUtils';
/**
 * Transform timespan to display format.
 * @returns Result string contains 2 units if first one less 5 and otherwise show 1 unit. (E.g. 1 day, 4 hours)
 * @param timeSpan
 *
 * TODO alex:
 * 1. consider move to "TimeSpanUtils.ts"
 * 2. consider using moment.humanize somehow
 */
export function humanize(duration: string): string {
  let result = '';
  let { days, hours, minutes, seconds } = getValue(duration);
  const weeks = Math.floor(days / 7);

  if (weeks > 0) {
    days -= 7 * weeks;
    result += weeks === 1 ? `${weeks} week` : `${weeks} weeks`;

    if (weeks < 5 && days > 0) {
      result += days === 1 ? ` ${days} day` : ` ${days} days`;
    }
  } else if (days > 0) {
    result += days === 1 ? `${days} day` : `${days} days`;

    if (days < 5 && hours > 0) {
      result += hours === 1 ? ` ${hours} hour` : ` ${hours} hours`;
    }
  } else if (hours > 0) {
    result += hours === 1 ? `${hours} hour` : `${hours} hours`;

    if (hours < 5 && minutes > 0) {
      result += minutes === 1 ? ` ${minutes} minute` : ` ${minutes} minutes`;
    }
  } else if (minutes > 0) {
    result += minutes === 1 ? `${minutes} minute` : `${minutes} minutes`;

    if (minutes < 5 && seconds > 0) {
      result += seconds === 1 ? ` ${seconds} second` : ` ${seconds} seconds`;
    }
  } else {
    result += seconds === 1 ? `${seconds} second` : `${seconds} seconds`;
  }

  return result;
}
